// src/components/page/home/HomePageContent.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import ViewModeControls from './ViewModeControls';
import ScheduleFilters from './ScheduleFilters';
import ScheduleView from './ScheduleView';
import ExportRangePanel from '@/components/ExportRangePanel';
import HiddenEasterEgg from '@/components/HiddenEasterEgg';
import { Link } from 'react-router-dom';
import PublicPrintButton from "@/components/PublicPrintButton";
const HomePageContent = ({
  viewMode,
  handleViewModeChange,
  ViewModes,
  selectedDate,
  handleDateChange,
  selectedGroup,
  setSelectedGroup,
  allGroups,
  selectedTeacher,
  setSelectedTeacher,
  allTeachers,
  teacherViewScope,
  setTeacherViewScope,
  TeacherViewScopes,
  selectedTeacherGroup,
  setSelectedTeacherGroup,
  selectedTeacherMonth,
  onTeacherMonthChange,
  teacherGroups,
  filteredSchedules,
  schedulesLoading,
  assignmentsLoading,
  showTools,
  setShowTools,
  clickCount,
  setClickCount,
  toast,
}) => {
  return (
    <motion.div
      className="w-full"
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.6, duration: 0.6 }}
    >
      <Card className="w-full shadow-2xl glassmorphic border-primary/20">
        <CardHeader className="space-y-4">
          <ViewModeControls
            viewMode={viewMode}
            onViewModeChange={handleViewModeChange}
            ViewModes={ViewModes}
          />
          <ScheduleFilters
            selectedDate={selectedDate}
            onDateChange={handleDateChange}
            viewMode={viewMode}
            ViewModes={ViewModes}
            selectedGroup={selectedGroup}
            onGroupChange={setSelectedGroup}
            allGroups={allGroups}
            selectedTeacher={selectedTeacher}
            onTeacherChange={setSelectedTeacher}
            allTeachers={allTeachers}
            teacherViewScope={teacherViewScope}
            onTeacherViewScopeChange={setTeacherViewScope}
            TeacherViewScopes={TeacherViewScopes}
            selectedTeacherGroup={selectedTeacherGroup}
            onTeacherGroupChange={setSelectedTeacherGroup}
            selectedTeacherMonth={selectedTeacherMonth}
            onTeacherMonthChange={onTeacherMonthChange}
            teacherGroups={teacherGroups}
          />
          {viewMode === ViewModes.BY_DATE && (
            <div className="hidden sm:block">
              <>
                <button
                  className="text-sm italic text-muted-foreground hover:text-primary transition"
                  onClick={() => {
                    setShowTools(prev => !prev);
                    setClickCount(prev => {
                      const next = prev + 1;
                      if (next === 3) {
                        toast({
                          title: "🎉 Ви офіційно архіватор розкладів!",
                          description: "Тепер вам відкрито доступ до друку, експорту і пасхалок.",
                          variant: "default"
                        });
                      }
                      return next;
                    });
                  }}
                >
                  📦 Жмякни мене, якщо ти з тих, хто ще друкує
                </button>
                {showTools && (
                  <div className="flex flex-row items-center gap-2 mt-2">
                    
                    <PublicPrintButton selectedDate={selectedDate} />

                    <HiddenEasterEgg />
                    <ExportRangePanel
                      schedules={filteredSchedules}
                      viewMode={viewMode}
                      selectedGroup={selectedGroup}
                      selectedTeacher={selectedTeacher}
                    />
                  </div>
                )}
              </>
            </div>
          )}
        </CardHeader>
        <CardContent className="px-2 sm:px-6">
          <ScheduleView
            schedulesLoading={schedulesLoading}
            assignmentsLoading={assignmentsLoading}
            viewMode={viewMode}
            ViewModes={ViewModes}
            filteredSchedules={filteredSchedules}   // ✅
            selectedGroup={selectedGroup}
            selectedTeacher={selectedTeacher}
            teacherViewScope={teacherViewScope}
            TeacherViewScopes={TeacherViewScopes}
            selectedDate={selectedDate}
          />
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default HomePageContent;
